var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilesGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 64,
    viewBox: "0 0 72 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.0002 9.80506L65.6693 64.0002L31.0042 59.8078L25.7894 59.1778L24.6128 59.0351L24.5317 59.0259L24.7274 57.3534L24.8973 55.9048L28.028 29.0921L30.6991 6.22427L30.8613 4.83203L41.5148 6.11949L72.0002 9.80506Z",
    fill: "#BBBDBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5625 49.8868C54.4788 49.8868 54.4016 49.8305 54.3771 49.744L42.3308 6.46676C42.3012 6.36198 42.3617 6.25327 42.4634 6.22446C42.5663 6.19433 42.6732 6.25589 42.7015 6.35936L54.7491 49.6366C54.7787 49.7414 54.7182 49.8501 54.6165 49.8789C54.5972 49.8842 54.5805 49.8868 54.5625 49.8868Z",
    fill: "#1D232A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8469 54.4136L28.7382 59.3368L25.7891 58.9767L25.9152 57.4652L28.0276 28.8045L29.7333 5.67081L30.776 5.18359L42.5173 6.41343L54.8469 54.4136Z",
    fill: "#1D232A",
    stroke: "#1D232A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4371 0.000438567L0 9.16797L11.6669 62.4398L52.104 53.2723L40.4371 0.000438567Z",
    fill: "#E8E9EA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15744 17.8692C8.06862 17.8692 7.9888 17.8064 7.9695 17.716C7.94632 17.6099 8.01198 17.5051 8.11624 17.4816L36.5561 11.0325C36.6604 11.0076 36.7633 11.0757 36.7865 11.1818C36.8097 11.2879 36.744 11.3927 36.6398 11.4162L8.19992 17.8653C8.18576 17.8679 8.1716 17.8692 8.15744 17.8692Z",
    fill: "#1D232A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0061 26.3068C9.91725 26.3068 9.83744 26.2439 9.81813 26.1535C9.79496 26.0474 9.86061 25.9427 9.96488 25.9191L38.4047 19.47C38.5077 19.4451 38.612 19.5132 38.6351 19.6193C38.6583 19.7254 38.5927 19.8302 38.4884 19.8537L10.0486 26.3015C10.0344 26.3041 10.0202 26.3068 10.0061 26.3068Z",
    fill: "#1D232A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8542 34.7439C11.7654 34.7439 11.6856 34.681 11.6663 34.5906C11.6431 34.4846 11.7088 34.3798 11.813 34.3562L40.2529 27.9071C40.3572 27.8835 40.4602 27.9503 40.4833 28.0564C40.5065 28.1625 40.4409 28.2673 40.3366 28.2908L11.8967 34.7386C11.8825 34.7413 11.8684 34.7439 11.8542 34.7439Z",
    fill: "#1D232A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7028 43.1814C13.614 43.1814 13.5342 43.1198 13.5149 43.0281C13.4917 42.922 13.5574 42.8173 13.6617 42.7937L42.1016 36.3446C42.2058 36.321 42.3088 36.3878 42.332 36.4939C42.3551 36.6 42.2895 36.7048 42.1852 36.7283L13.7453 43.1774C13.7299 43.1801 13.7157 43.1814 13.7028 43.1814Z",
    fill: "#1D232A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.55 51.6195C15.4612 51.6195 15.3814 51.558 15.3621 51.4663C15.3389 51.3602 15.4046 51.2554 15.5088 51.2319L35.5775 46.6805C35.6805 46.6569 35.7848 46.7237 35.808 46.8298C35.8311 46.9359 35.7655 47.0407 35.6612 47.0643L15.5925 51.6156C15.5783 51.6182 15.5642 51.6195 15.55 51.6195Z",
    fill: "#1D232A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesGrey);
export default __webpack_public_path__ + "static/media/files-grey.517186009f8414b17322440aaf76fde9.svg";
export { ForwardRef as ReactComponent };